var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartCustomisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 488 c-15 -15 24 -92 42 -85 7 3 47 -29 89 -71 62 -62 75 -81 71 -99 -5 -18 -1 -25 20 -33 15 -5 29 -18 33 -27 11 -33 156 -173 179 -173 25 0 54 29 54 54 0 22 -136 165 -168 177 -12 5 -27 20 -32 35 -8 21 -15 25 -33 20 -18 -4 -37 9 -99 71 -42 42 -74 82 -71 89 7 18 -70 57 -85 42z m368 -353 c29 -30 51 -58 47 -62 -8 -7 -117 95 -117 109 0 18 18 5 70 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 479 c-47 -24 -62 -52 -54 -97 4 -26 1 -41 -11 -54 -15 -17 -14 -18 13 -18 35 0 54 -16 54 -44 0 -15 3 -17 12 -8 7 7 27 9 54 5 36 -5 46 -2 67 20 29 28 53 97 43 123 -6 15 -11 13 -41 -16 l-35 -34 -32 32 -32 32 32 33 c18 18 29 36 26 40 -13 13 -59 6 -96 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 231 c-20 -21 -39 -31 -59 -31 -39 0 -64 -15 -82 -50 -24 -47 -19 -78 20 -117 32 -32 39 -35 78 -30 52 7 87 44 87 91 0 20 8 40 20 51 25 23 25 28 -2 40 -15 7 -25 21 -28 43 l-5 34 -29 -31z m-22 -100 c36 -40 -23 -98 -62 -59 -20 20 -14 58 11 68 31 12 32 12 51 -9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartCustomisation);
export default __webpack_public_path__ + "static/media/ChartCustomisation.5dcfedbadbcec061932e9e1395c3bba9.svg";
export { ForwardRef as ReactComponent };